import React, { ReactNode } from "react";
import { Navigate } from 'react-router-dom';

const Pages = React.lazy(() => import("../pages/convergence-2025/convergence-2025-index"));
const PageNotFound = React.lazy(() => import("../pages/errors/page-not-found"));

export type route = {
  component: ReactNode;
  path: string;
  routes?: route[];
  [propName: string]: any;
};

const Routes: route[] = [
  { path: '/', exact: true, name: 'Convergence 2025 Recap', component: <Navigate to={`/convergence-2025/home${window.location.search}`} replace /> },
  { path: '/*', exact: true, name: 'Convergence 2025 All', component: <Pages /> },

  { path: '/*', exact: true, component: <PageNotFound /> },
]

export default Routes;